<template>
  <div id="app" class="container-fluid">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: 'app',
  created () {
    this.$store.dispatch('tryAutoLogin',{vm: this})
  }
}
</script>
<style>
#app {
}
</style>



// WEBPACK FOOTER //
// App.vue?45b5795c